import { ReadinessCategory, ReadinessSeverity, ReadinessState } from '../../../shared/services/readiness/readiness.model'

// Display vocabulary for the readiness surface. Severity copy is deliberately honest: the
// system detects gaps and anomalies, it does not know a "mistake" (a legitimate business fact
// can look identical to one), so nothing here says error.
export const READINESS_SEVERITY_ORDER: ReadinessSeverity[] = ['blocks_reporting', 'needs_decision', 'worth_checking']

export const READINESS_SEVERITY_LABELS: Record<ReadinessSeverity, string> = {
  blocks_reporting: 'Critical',
  needs_decision: 'Action required',
  worth_checking: 'Advisory',
}

export const READINESS_SEVERITY_DESCRIPTIONS: Record<ReadinessSeverity, string> = {
  blocks_reporting: 'the report will be wrong or incomplete until these are fixed',
  needs_decision: 'defensible either way, but silence is not',
  worth_checking: 'anomalies and quality improvements; often no action is needed',
}

export const READINESS_STATE_LABELS: Record<ReadinessState, string> = {
  not_ready: 'Not ready',
  reportable_with_caveats: 'Reportable with caveats',
  audit_ready: 'Audit ready',
}

export const READINESS_CATEGORY_LABELS: Record<ReadinessCategory, string> = {
  completeness: 'Completeness',
  consistency: 'Consistency',
  compliance: 'Compliance',
  governance: 'Governance',
}

// Chip colour per severity. Red is reserved for genuine failures and amber overstates it; a
// finding is detected work, not an alarm. The most severe wears the brand ink, then blue, then
// grey. Ink is applied by sx (MUI Chip has no ink colour), signalled here by 'ink'. Shared by the
// checks list and the partner console so the two surfaces never colour a severity differently.
export type ReadinessSeverityChipColor = 'ink' | 'info' | 'default'

export const READINESS_SEVERITY_CHIP_COLORS: Record<ReadinessSeverity, ReadinessSeverityChipColor> = {
  blocks_reporting: 'ink',
  needs_decision: 'info',
  worth_checking: 'default',
}

// Text colour for a severity, for captions that name a count ("2 Critical") without a chip.
export const READINESS_SEVERITY_TEXT_COLORS: Record<ReadinessSeverity, string> = {
  blocks_reporting: 'text.primary',
  needs_decision: 'info.main',
  worth_checking: 'text.secondary',
}
